
export default function (Component) {
  Component.options.__source = "src/components/EchartTools/Tools/btnTools.vue"
}
